import React, { createContext, useContext, useEffect, useState } from "react";
import { api, onUsageChanged } from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  // Bumped every time anything in /scrape* or /billing* succeeds.
  // Pages that show usage data subscribe to this and refetch.
  const [usageVersion, setUsageVersion] = useState(0);

  useEffect(() => {
    const token = localStorage.getItem("ps_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("ps_token"))
      .finally(() => setLoading(false));
  }, []);

  // Whenever a usage-mutating call succeeds, refresh the user record so
  // credits_used / plan / credits_limit are always live, and bump version
  // so subscribed pages refetch their analytics/usage payloads.
  useEffect(() => {
    const off = onUsageChanged(() => {
      setUsageVersion((v) => v + 1);
      api.get("/auth/me").then((r) => setUser(r.data)).catch(() => {});
    });
    return off;
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("ps_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const register = async (email, password, name) => {
    const r = await api.post("/auth/register", { email, password, name });
    localStorage.setItem("ps_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = () => {
    localStorage.removeItem("ps_token");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, loading, login, register, logout, usageVersion }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
